import { Reveal, SectionHeader } from "../site/Reveal";

export default function StepsList({ overline, title, titleEm, steps, testId = "steps-list" }) {
  return (
    <section data-testid={testId} className="py-24 lg:py-32 bg-ivory">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-[0.8fr_1.2fr] gap-14">
        <SectionHeader overline={overline} title={<>{title} {titleEm && <em className="italic font-medium">{titleEm}</em>}</>} />
        <ol className="divide-y divide-navy/10 border-y border-navy/10">
          {steps.map(({ title: t, text }, i) => (
            <li key={t}>
              <Reveal delay={i * 0.06} className="group flex gap-8 py-7">
                <span className="font-display text-2xl text-navy/40 w-10 shrink-0 transition-colors duration-300 group-hover:text-navy">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <h3 className="font-display text-xl text-navy">{t}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-charcoal/75 max-w-xl">{text}</p>
                </div>
              </Reveal>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
